import React from 'react';

const LABELS = {
  spring: { label: 'Spring', emoji: '🌸' },
  summer: { label: 'Summer', emoji: '☀️' },
  fall:   { label: 'Fall',   emoji: '🍂' },
  winter: { label: 'Winter', emoji: '❄️' },
};

const ORDER = ['spring', 'summer', 'fall', 'winter'];

// Pill-style season switcher. Seasons without a photo are dimmed but still selectable.
export default function SeasonSwitcher({
  current,
  onChange,
  hasPhoto = {}, // { spring: bool, summer: bool, ... }
  size = 'md',
}) {
  const sizeCls = size === 'sm' ? 'text-xs px-2.5 py-1' : 'text-sm px-3 py-1.5';
  return (
    <div
      role="tablist"
      aria-label="Season"
      className="inline-flex gap-1 p-1 rounded-full bg-white/90 shadow-sm border border-black/5"
    >
      {ORDER.map((s) => {
        const { label, emoji } = LABELS[s];
        const active = current === s;
        const filled = !!hasPhoto[s];
        return (
          <button
            key={s}
            role="tab"
            aria-selected={active}
            onClick={() => onChange?.(s)}
            className={
              `rounded-full font-medium transition flex items-center gap-1 min-h-9 ${sizeCls} ` +
              (active
                ? 'bg-garden-primary text-white'
                : filled
                  ? 'text-garden-ink hover:bg-garden-primaryLight'
                  : 'text-garden-muted hover:bg-black/5')
            }
          >
            <span aria-hidden>{emoji}</span>
            <span>{label}</span>
          </button>
        );
      })}
    </div>
  );
}
